
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as account5ogUcMkb0cMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/account.vue?macro=true";
import { default as adminimpf74GZIVMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/admin.vue?macro=true";
import { default as confirmr0GEM3eiBjMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/auth/confirm.vue?macro=true";
import { default as forgot_45password0A4i2ywNKpMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/auth/forgot-password.vue?macro=true";
import { default as login59lgoLK3hcMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/auth/login.vue?macro=true";
import { default as signupafbp1QaWKzMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/auth/signup.vue?macro=true";
import { default as dashboardALJ3ZQj2KeMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/dashboard.vue?macro=true";
import { default as indexJnlBr14PIBMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/index.vue?macro=true";
import { default as magic_45confirm0z4SlXRujQMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/magic-confirm.vue?macro=true";
import { default as offersm57YVr5CDZMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/offers.vue?macro=true";
import { default as price_45adjustmentsUxEjE5hdQ4Meta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/price-adjustments.vue?macro=true";
import { default as recalls3jwgLdPq2vMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/recalls.vue?macro=true";
import { default as _91id_93cvrVMILU9hMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/receipts/[id].vue?macro=true";
import { default as indexuH6dOGX6iKMeta } from "/Users/rayyach/Desktop/sites/saveAtCost.co/pages/receipts/index.vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    meta: account5ogUcMkb0cMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/account.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: adminimpf74GZIVMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/admin.vue")
  },
  {
    name: "auth-confirm",
    path: "/auth/confirm",
    meta: confirmr0GEM3eiBjMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/auth/confirm.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45password0A4i2ywNKpMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: login59lgoLK3hcMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/auth/login.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    meta: signupafbp1QaWKzMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/auth/signup.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardALJ3ZQj2KeMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/dashboard.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexJnlBr14PIBMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/index.vue")
  },
  {
    name: "magic-confirm",
    path: "/magic-confirm",
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/magic-confirm.vue")
  },
  {
    name: "offers",
    path: "/offers",
    meta: offersm57YVr5CDZMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/offers.vue")
  },
  {
    name: "price-adjustments",
    path: "/price-adjustments",
    meta: price_45adjustmentsUxEjE5hdQ4Meta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/price-adjustments.vue")
  },
  {
    name: "recalls",
    path: "/recalls",
    meta: recalls3jwgLdPq2vMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/recalls.vue")
  },
  {
    name: "receipts-id",
    path: "/receipts/:id()",
    meta: _91id_93cvrVMILU9hMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/receipts/[id].vue")
  },
  {
    name: "receipts",
    path: "/receipts",
    meta: indexuH6dOGX6iKMeta || {},
    component: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/pages/receipts/index.vue")
  }
]